import styled from "styled-components"


export const CorporationSettingsContainer = styled.div`

`